import { Action } from '@ngrx/store';

export enum ECompanyEmployeeActions {
  GetAllCompanyEmployes = '[CompanyEmployee] Get All CompanyEmployee',
  GetAllCompanyEmployesSuccess = '[CompanyEmployee] Set All CompanyEmployee Success',
  GetAllCompanyEmployesError = ' Set All CompanyEmployee Error',
  GetAllCompanyEmployesReset = ' Set All CompanyEmployee Reset',
  AddCompanyEmployee = '[CompanyEmployee] Get Add CompanyEmployee',
  GetAddCompanyEmployeeSuccess = '[CompanyEmployee] Set Add CompanyEmployee Success',
  GetAddCompanyEmployeeError = ' Set Add CompanyEmployee Error',
  EditCompanyEmployee = '[CompanyEmployee] Get Edit CompanyEmployee',
  GetEditCompanyEmployeeSuccess = '[CompanyEmployee] Set Edit CompanyEmployee Success',
  GetEditCompanyEmployeeError = ' Set Edit CompanyEmployee Error',
  GetEmployeesByRole = '[CompanyEmployee] Get All Employees By Roles',
  GetAllCompanyEmployesByRoleSuccess = '[CompanyEmployee] Set All CompanyEmployee ByRole Success',
  GetAllCompanyEmployesByRoleError = ' Set All CompanyEmployee ByRole Error',
  LoginCompanyEmployee = '[CompanyEmployee] Login CompanyEmployee',
  LoginCompanyEmployeeSuccess = '[CompanyEmployee] Set Login CompanyEmployee Success',
  LoginCompanyEmployeeError = '[CompanyEmployee] Set Login CompanyEmployee Error',
  SendLinkCompanyEmployeeFrgtPswd = '[CompanyEmployee] Check Username',
  SendLinkCompanyEmployeeFrgtPswdSuccess = '[CompanyEmployee] Set Check Username Success',
  SendLinkCompanyEmployeeFrgtPswdError = '[CompanyEmployee] Set Check Username Error',
  CompanyEmployeeResetPassword = '[CompanyEmployee] Reset Password',
  CompanyEmployeeResetPasswordSuccess = '[CompanyEmployee] Set Reset password Success',
  CompanyEmployeeResetPasswordError = '[CompanyEmployee] Set Reset password Error',
  GetEmployeesToAddMasterUser = '[CompanyEmployee] Get CompanyEmployee For Master User',
  GetEmployeesToAddMasterUserSuccess = '[CompanyEmployee] Set CompanyEmployee For Master User Success',
  SetCompanyEmployeesErrorMsg = '[CompanyEmployee] Set CompanyEmployee Error Msg',
  GetEmployeesToAddSubUser = '[CompanyEmployee] Get CompanyEmployee For Sub User',
  GetEmployeesToAddSubUserSuccess = '[CompanyEmployee] Get CompanyEmployee For Sub User Success',
  GetEmployeesToAddSubUserError = '[CompanyEmployee] Get CompanyEmployee For Sub User Error',

  RemoveCmpyUsers = '[CompanyEmployee] Remove Cmpy Users',
  GetRemoveCmpyUsersSuccess = '[CompanyEmployee] Get Remove Cmpy Users Success',
  GetRemoveCmpyUsersError = '[CompanyEmployee] Get Remove Cmpy Users Error',

  RemoveUserRoles = '[CompanyEmployee] Remove User Roles',
  GetRemoveUserRolesSuccess = '[CompanyEmployee] Get Remove User Roles Success',
  GetRemoveUserRolesError = '[CompanyEmployee] Get Remove User Roles Error',

  GetUpdatedRoleUser = '[CompanyEmployee] Get Updated User Roles',
  GetUpdatedRoleUserSuccess = '[CompanyEmployee] Get Updated User Roles Success',
  GetUpdatedRoleUserError = '[CompanyEmployee] Get Updated User Roles Error',

  GetAllSalesControllerUsers = '[CompanyEmployee] Get All Sales Controller users',
  GetAllSalesControllerUsersSuccess = '[CompanyEmployee] Get All Sales Controller users Success',
  GetAllSalesControllerUsersError = '[] Get All Sales Controller users Error',
  GetAllWarehouseControllerUsers = '[CompanyEmployee] Get All Warehouse Controller users',
  GetAllWarehouseControllerUsersSuccess = '[CompanyEmployee] Get All Warehouse Controller users Success',
  GetAllWarehouseControllerUsersError = '[] Get All Warehouse Controller users Error',

  GetAllWarehouseandProductionControllerUsers = '[CompanyEmployee] Get All Warehouse and Production Controller users',
  GetAllWarehouseandProductionControllerUsersSuccess = '[CompanyEmployee] Get All Warehouse and Production Controller users Success',
  GetAllWarehouseandProductionControllerUsersError = '[] Get All Warehouse and Production Controller users Error',
}

export class GetAllCompanyEmployes implements Action {
  public readonly type = ECompanyEmployeeActions.GetAllCompanyEmployes;
  constructor(public payload: any) {}
}
export class GetAllCompanyEmployesSuccess implements Action {
  public readonly type = ECompanyEmployeeActions.GetAllCompanyEmployesSuccess;
  constructor(public payload: any) {
    // console.log(payload)
  }
}
export class GetAllCompanyEmployesReset implements Action {
  public readonly type = ECompanyEmployeeActions.GetAllCompanyEmployesReset;
}
export class GetAllCompanyEmployesError implements Action {
  public readonly type = ECompanyEmployeeActions.GetAllCompanyEmployesError;
  constructor(public payload: any) {}
}
export class AddCompanyEmployee implements Action {
  public readonly type = ECompanyEmployeeActions.AddCompanyEmployee;
  constructor(public payload: any) {}
}
export class GetAddCompanyEmployeeSuccess implements Action {
  public readonly type = ECompanyEmployeeActions.GetAddCompanyEmployeeSuccess;
  constructor(public payload: any) {}
}
export class GetAddCompanyEmployeeError implements Action {
  public readonly type = ECompanyEmployeeActions.GetAddCompanyEmployeeError;
  constructor(public payload: any) {}
}
export class EditCompanyEmployee implements Action {
  public readonly type = ECompanyEmployeeActions.EditCompanyEmployee;
  constructor(public payload: any) {}
}
export class GetEditCompanyEmployeeSuccess implements Action {
  public readonly type = ECompanyEmployeeActions.GetEditCompanyEmployeeSuccess;
  constructor(public payload: any) {}
}
export class GetEditCompanyEmployeeError implements Action {
  public readonly type = ECompanyEmployeeActions.GetEditCompanyEmployeeError;
  constructor(public payload: any) {}
}
export class GetEmployeesByRole implements Action {
  public readonly type = ECompanyEmployeeActions.GetEmployeesByRole;
  constructor(public payload: any) {}
}
export class GetAllCompanyEmployesByRoleSuccess implements Action {
  public readonly type =
    ECompanyEmployeeActions.GetAllCompanyEmployesByRoleSuccess;
  constructor(public payload: any) {
    // console.log(payload)
  }
}
export class GetAllCompanyEmployesByRoleError implements Action {
  public readonly type =
    ECompanyEmployeeActions.GetAllCompanyEmployesByRoleError;
  constructor(public payload: any) {}
}
export class LoginCompanyEmployee implements Action {
  public readonly type = ECompanyEmployeeActions.LoginCompanyEmployee;
  constructor(public payload: any) {}
}
export class LoginCompanyEmployeeSuccess implements Action {
  public readonly type = ECompanyEmployeeActions.LoginCompanyEmployeeSuccess;
  constructor(public payload: any) {}
}
export class LoginCompanyEmployeeError implements Action {
  public readonly type = ECompanyEmployeeActions.LoginCompanyEmployeeError;
  constructor(public payload: any) {}
}
export class SendLinkCompanyEmployeeFrgtPswd implements Action {
  public readonly type =
    ECompanyEmployeeActions.SendLinkCompanyEmployeeFrgtPswd;
  constructor(public payload: any) {}
}
export class SendLinkCompanyEmployeeFrgtPswdSuccess implements Action {
  public readonly type =
    ECompanyEmployeeActions.SendLinkCompanyEmployeeFrgtPswdSuccess;
  constructor(public payload: any) {
    // console.log(payload)
  }
}
export class SendLinkCompanyEmployeeFrgtPswdError implements Action {
  public readonly type =
    ECompanyEmployeeActions.SendLinkCompanyEmployeeFrgtPswdError;
  constructor(public payload: any) {
    // console.log(payload)
  }
}
export class CompanyEmployeeResetPassword implements Action {
  public readonly type = ECompanyEmployeeActions.CompanyEmployeeResetPassword;
  constructor(public payload: any) {}
}
export class CompanyEmployeeResetPasswordSuccess implements Action {
  public readonly type =
    ECompanyEmployeeActions.CompanyEmployeeResetPasswordSuccess;
  constructor(public payload: any) {}
}
export class CompanyEmployeeResetPasswordError implements Action {
  public readonly type =
    ECompanyEmployeeActions.CompanyEmployeeResetPasswordError;
  constructor(public payload: any) {}
}
export class GetEmployeesToAddMasterUser implements Action {
  public readonly type = ECompanyEmployeeActions.GetEmployeesToAddMasterUser;
  constructor(public payload: any) {}
}
export class GetEmployeesToAddMasterUserSuccess implements Action {
  public readonly type =
    ECompanyEmployeeActions.GetEmployeesToAddMasterUserSuccess;
  constructor(public payload: any) {}
}
export class SetCompanyEmployeesErrorMsg implements Action {
  public readonly type = ECompanyEmployeeActions.SetCompanyEmployeesErrorMsg;
  constructor(public payload: any) {}
}
export class GetEmployeesToAddSubUser implements Action {
  public readonly type = ECompanyEmployeeActions.GetEmployeesToAddSubUser;
  constructor(public payload: any) {}
}
export class GetEmployeesToAddSubUserSuccess implements Action {
  public readonly type =
    ECompanyEmployeeActions.GetEmployeesToAddSubUserSuccess;
  constructor(public payload: any) {}
}
export class GetEmployeesToAddSubUserError implements Action {
  public readonly type = ECompanyEmployeeActions.GetEmployeesToAddSubUserError;
  constructor(public payload: any) {}
}
export class RemoveCmpyUsers implements Action {
  public readonly type = ECompanyEmployeeActions.RemoveCmpyUsers;
  constructor(public payload: any) {}
}
export class GetRemoveCmpyUsersSuccess implements Action {
  public readonly type = ECompanyEmployeeActions.GetRemoveCmpyUsersSuccess;
  constructor(public payload: any) {}
}
export class GetRemoveCmpyUsersError implements Action {
  public readonly type = ECompanyEmployeeActions.GetRemoveCmpyUsersError;
  constructor(public payload: any) {}
}
export class RemoveUserRoles implements Action {
  public readonly type = ECompanyEmployeeActions.RemoveUserRoles;
  constructor(public payload: any) {}
}
export class GetRemoveUserRolesSuccess implements Action {
  public readonly type = ECompanyEmployeeActions.GetRemoveUserRolesSuccess;
  constructor(public payload: any) {}
}
export class GetRemoveUserRolesError implements Action {
  public readonly type = ECompanyEmployeeActions.GetRemoveUserRolesError;
  constructor(public payload: any) {}
}
export class GetUpdatedRoleUser implements Action {
  public readonly type = ECompanyEmployeeActions.GetUpdatedRoleUser;
  constructor(public payload: any) {}
}
export class GetUpdatedRoleUserSuccess implements Action {
  public readonly type = ECompanyEmployeeActions.GetUpdatedRoleUserSuccess;
  constructor(public payload: any) {}
}
export class GetUpdatedRoleUserError implements Action {
  public readonly type = ECompanyEmployeeActions.GetUpdatedRoleUserError;
  constructor(public payload: any) {}
}
export class GetAllSalesControllerUsers implements Action {
  public readonly type = ECompanyEmployeeActions.GetAllSalesControllerUsers;
  constructor(public payload: any) {}
}
export class GetAllSalesControllerUsersSuccess implements Action {
  public readonly type =
    ECompanyEmployeeActions.GetAllSalesControllerUsersSuccess;
  constructor(public payload: any) {}
}
export class GetAllSalesControllerUsersError implements Action {
  public readonly type =
    ECompanyEmployeeActions.GetAllSalesControllerUsersError;
  constructor(public payload: any) {}
}
export class GetAllWarehouseControllerUsers implements Action {
  public readonly type = ECompanyEmployeeActions.GetAllWarehouseControllerUsers;
  constructor(public payload: any) {}
}
export class GetAllWarehouseControllerUsersSuccess implements Action {
  public readonly type =
    ECompanyEmployeeActions.GetAllWarehouseControllerUsersSuccess;
  constructor(public payload: any) {}
}
export class GetAllWarehouseControllerUsersError implements Action {
  public readonly type =
    ECompanyEmployeeActions.GetAllWarehouseControllerUsersError;
  constructor(public payload: any) {}
}
export class GetAllWarehouseandProductionControllerUsers implements Action {
  public readonly type =
    ECompanyEmployeeActions.GetAllWarehouseandProductionControllerUsers;
  constructor(public payload: any) {}
}
export class GetAllWarehouseandProductionControllerUsersSuccess
  implements Action
{
  public readonly type =
    ECompanyEmployeeActions.GetAllWarehouseandProductionControllerUsersSuccess;
  constructor(public payload: any) {}
}
export class GetAllWarehouseandProductionControllerUsersError
  implements Action
{
  public readonly type =
    ECompanyEmployeeActions.GetAllWarehouseandProductionControllerUsersError;
  constructor(public payload: any) {}
}
export type CompanyEmployeeAction =
  | GetAllCompanyEmployes
  | GetAllCompanyEmployesSuccess
  | GetAllCompanyEmployesError
  | GetAllCompanyEmployesReset
  | AddCompanyEmployee
  | GetAddCompanyEmployeeSuccess
  | GetAddCompanyEmployeeError
  | EditCompanyEmployee
  | GetEditCompanyEmployeeSuccess
  | GetEditCompanyEmployeeError
  | GetEmployeesByRole
  | LoginCompanyEmployee
  | LoginCompanyEmployeeSuccess
  | LoginCompanyEmployeeError
  | SendLinkCompanyEmployeeFrgtPswd
  | SendLinkCompanyEmployeeFrgtPswdSuccess
  | SendLinkCompanyEmployeeFrgtPswdError
  | CompanyEmployeeResetPassword
  | CompanyEmployeeResetPasswordSuccess
  | CompanyEmployeeResetPasswordError
  | GetAllCompanyEmployesByRoleSuccess
  | GetAllCompanyEmployesByRoleError
  | GetEmployeesToAddMasterUser
  | GetEmployeesToAddMasterUserSuccess
  | SetCompanyEmployeesErrorMsg
  | RemoveCmpyUsers
  | GetRemoveCmpyUsersSuccess
  | GetRemoveCmpyUsersError
  | GetEmployeesToAddSubUser
  | GetEmployeesToAddSubUserSuccess
  | GetEmployeesToAddSubUserError
  | RemoveUserRoles
  | GetRemoveUserRolesSuccess
  | GetRemoveUserRolesError
  | GetUpdatedRoleUser
  | GetUpdatedRoleUserSuccess
  | GetUpdatedRoleUserError
  | GetAllSalesControllerUsers
  | GetAllSalesControllerUsersSuccess
  | GetAllSalesControllerUsersError
  | GetAllWarehouseControllerUsers
  | GetAllWarehouseControllerUsersSuccess
  | GetAllWarehouseControllerUsersError
  | GetAllWarehouseandProductionControllerUsers
  | GetAllWarehouseandProductionControllerUsersSuccess
  | GetAllWarehouseandProductionControllerUsersError;
